import {
  deleteCostItem,
  getCommonOption,
  getCostItemDetail,
  getCostItemList,
  saveCostItem,
} from '../services';

export default {
  namespace: 'costItem',
  state: {},
  effects: {
    // 分页展示费用项列表
    *getCostItemList({ payload }, { call }) {
      return yield call(getCostItemList, payload);
    },

    // 新增、编辑费用项
    *saveCostItem({ payload }, { call }) {
      return yield call(saveCostItem, payload);
    },

    // 删除费用项
    *deleteCostItem({ payload }, { call }) {
      return yield call(deleteCostItem, payload);
    },

    // 查看费用项详情
    *getCostItemDetail({ payload }, { call }) {
      return yield call(getCostItemDetail, payload);
    },

    // 查看费用项详情
    *getCommonOption({ payload }, { call, put }) {
      return yield call(getCommonOption, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
